import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class ApiUrlInterceptor implements HttpInterceptor {
	constructor() {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (!request.url.startsWith(environment.apiUrl) && !request.url.startsWith('https://') && !request.url.startsWith('http://')) {
			request = request.clone({ url: `${environment.apiUrl}${request.url}` });
		}

		return next.handle(request);
	}
}
